import React, { memo } from 'react';
import Skeleton from './Skeleton';

const NotificationSkeleton = memo(function NotificationSkeleton({ count = 4, style = {} }) {
  return (
    <div aria-busy="true" style={{ width: '100%', ...style }}>
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          style={{
            background: '#FFFFFF',
            borderRadius: 12,
            border: '1.5px solid var(--border, #E5E7EB)',
            padding: 16,
            marginBottom: 12,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 14,
          }}
        >
          <Skeleton variant="circular" width={40} height={40} />
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <Skeleton variant="text" width={160} height={14} />
              <Skeleton variant="text" width={50} height={10} />
            </div>
            <Skeleton variant="text" width="90%" height={12} style={{ marginBottom: 4 }} />
            <Skeleton variant="text" width="60%" height={12} />
          </div>
        </div>
      ))}
    </div>
  );
});

export default NotificationSkeleton;
